/**
 * Traduções de login e registro
 * Inclui: Formulário de login, login de terceiros, processo de registro, autenticação
 */
export default {
  success: 'Login realizado com sucesso!',
  failed: 'Falha no login, tente novamente',
  pleaseCheckAgreement: 'Por favor, aceite o acordo primeiro',
  processing: 'Fazendo login...',
  webviewNotSupported: 'Login não suportado em navegador incorporado',
  signInWithGoogle: 'Entrar com Google',
  continueWithApple: 'Continuar com Apple',
  termsText: 'Certifico que li e concordo com os {terms} e confirmo que li a {privacy}. Certifico que tenho pelo menos 18 anos e atingi a maioridade onde moro.',
  termsOfService: 'Termos de Serviço',
  privacyPolicy: 'Política de Privacidade',
  // Autenticação
  authenticating: 'Autenticando...',
  loadSDKFailed: 'Falha ao carregar Serviços do {name}',
  initializing: 'Inicializando Serviços do {name}...',
  logoutFailed: 'Falha ao cancelar autorização do {name}',
  authenticationFailed: 'Falha na autorização do {name}',
  authCancelled: 'Autorização cancelada',
  stateValidationFailed: 'Falha na validação de estado',
  invalidOAuthRedirect: 'Redirecionamento OAuth inválido',
  codeVerifierNotFound: 'codeVerifier não encontrado',
  popupBlocked: 'Pop-up bloqueado',
}
